import React, { useContext, useState } from 'react'
import { deleteItem } from '../store/Actions'
import { DataContext } from '../store/GlobalState'
import Prestataire from '../Services/Prestataire'
import { toast } from 'react-toastify'
import { getDataByID } from '../utils/fetchData'

export default function DeleteModalPrestataire() {
  const { state, dispatch } = useContext(DataContext)
  const [isLoading, setIsLoading] = useState(false)

  const { auth, prestataire, prestataires } = state

  const requestConfig = {
    headers: {
      Authorization: `Bearer ${auth?.token}`,
    },
  }

  const handleDelete = async () => {
    setIsLoading(true)
    var prestataireRequest = Prestataire.deletePrestataire(
      prestataire.id,
      requestConfig,
    )
    await prestataireRequest
      .then((response) => {
        var prestataireInfos = response
        console.log('prestataire', prestataireInfos)

        dispatch(deleteItem(prestataires, prestataire.id, 'ADD_PRESTATAIRE'))
        setIsLoading(false)
        // getDataByID('prestatairebyassurance', auth?.user?.id, auth.token)
        //     .then((res) => {
        //       dispatch({
        //         type: 'PRESTATAIRE_BY_IPM',
        //         payload: res.results.reverse(),
        //       })
        //     })
        //     .catch((e) => {
        //       console.log('e', e)
        //     })
        window.$('.delete-prestataire-modal').modal('hide')
        dispatch({ type: 'EDIT_PRESTATAIRE', payload: {} })
        toast.success('Prestataire supprimé !')
      })
      .catch((error) => {
        console.log(error)
        setIsLoading(false)
        toast.error('Oupss! Une erreur est survenue lors de la suppréssion.')
      })
  }
  return (
    <div className="modal-dialog easypm-modal-dialog modal-md">
      <div className="modal-content easypm-modal-content">
        <div className="modal-header easypm-modal-header">
          <h5
            className="modal-title easypm-modal-title"
            id="DeletingFamilyModal"
          >
            Suppression d'un prestataire
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => dispatch({ type: 'EDIT_PRESTATAIRE', payload: {} })}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body easypm-modal-body">
          <div className="deleting-family-form-container">
            <div className="alert-delete-message">
              <span>Êtes vous sûr de vouloir supprimer ce prestataire ?</span>
            </div>
            
            <div className="row delete-row">
              <div className="col-md-10 offset-md-2 crud-form-action-btn-container">
                  <button
                    onClick={() =>
                      dispatch({ type: 'EDIT_PRESTATAIRE', payload: {} })
                    }
                    className="btn btn-default cancelleb-btn delete-actions"
                    data-dismiss="modal"
                  >
                    Retour
                  </button>
                  {!isLoading ? (
                    <button
                      className="btn btn-primary crud-submit-btn delete-actions"
                      onClick={handleDelete}
                    >
                      Valider
                    </button>
                  ) : (
                    <button className="btn btn-primary crud-submit-btn delete-actions">
                      En cours &nbsp;
                      <i className="fas fa-spin fa-spinner"></i>
                    </button>
                  )}
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
